import { useEffect, useRef, useState } from 'react';

import { useSelector } from 'react-redux';

import { eventBus } from '@atc/cai-event-bus';

import paymentsDuck from '@/ducks/paymentsDuck.js';

const usePaymentData = (supportedDealTypes) => {
    const [hasError, setHasError] = useState(false);
    const [localPayments, setLocalPayments] = useState(null);
    const [paymentsData, setPaymentsData] = useState(null);
    const paymentsRef = useRef(localPayments);

    const isLoading = useSelector(paymentsDuck.selectors.getIsLoading);

    // setting error on timeout
    useEffect(() => {
        setTimeout(() => {
            if (paymentsRef.current && Object.keys(paymentsRef.current).length === 0) {
                setHasError(true);
            }
        }, 5000);
    }, []);

    const handlePaymentObjectUpdate = (paymentObj) => {
        setLocalPayments(paymentObj);
    };

    useEffect(() => {
        eventBus.on(
            'uds:PaymentObject:Update',
            handlePaymentObjectUpdate
        );

        return () => {
            eventBus.off(
                'uds:PaymentObject:Update',
                handlePaymentObjectUpdate
            );
        };
    }, []);

    useEffect(() => {
        // update ref to current value for timeout
        paymentsRef.current = localPayments;
        setPaymentsData(localPayments);

    }, [localPayments, supportedDealTypes]);

    return [isLoading, hasError, paymentsData];
};

export default usePaymentData;
